import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { TAG_CLOSE_ARIA_LABEL } from '@/constants/global';
import { Tag, TagColorsTypes } from '@proprioo/salatim';

import { LocationState } from '../interfaces';

export type CriteriaSelectionProps = {
  areas: LocationState[];
  removeArea(id: string): void;
};

const CriteriaSelection: FC<CriteriaSelectionProps> = ({
  areas,
  removeArea
}) => {
  const { t } = useTranslation();

  return (
    <div data-test="areas-selected">
      {areas.map(({ id, name }) => (
        <Tag
          closeAriaLabel={t(TAG_CLOSE_ARIA_LABEL)}
          color={TagColorsTypes.TERRACOTA}
          dataTest={id}
          key={id}
          labels={[name]}
          onClose={() => removeArea(id)}
        />
      ))}
    </div>
  );
};

export default CriteriaSelection;
